(() => {
  const PREFIX_WRAPPER = 'family-tree-wrapper-';

  function initFamilyTree(scope) {
    if (!scope) return;

    const wrapper = scope.querySelector(`[id^="${PREFIX_WRAPPER}"]`);
    if (!wrapper || wrapper.dataset.initialized === 'true') return;

    const sectionId = wrapper.id.replace(PREFIX_WRAPPER, '');
    const form = scope.querySelector('form[data-type="add-to-cart-form"]');
    const familyTreeForm = scope.querySelector(`#family-tree-form-${sectionId}`);
    const hiddenInput = scope.querySelector(`#family-tree-json-${sectionId}`);
    const toggleButton = scope.querySelector(`#family-tree-toggle-${sectionId}`);
    const closeButton = wrapper.querySelector('.family-tree-close');
    const optionInputs = Array.from(scope.querySelectorAll(`input[name="customize_choice_${sectionId}"]`));

    if (!form || !familyTreeForm || !hiddenInput || !toggleButton || !closeButton) return;

    wrapper.dataset.initialized = 'true';

    const customizeChoiceInput = document.createElement('input');
    customizeChoiceInput.type = 'hidden';
    customizeChoiceInput.name = 'properties[customize_choice]';
    form.appendChild(customizeChoiceInput);

    const productId = form.dataset.productId || 'unknown';
    const storageKey = `familyTreeData_${productId}`;
    const choiceStorageKey = `familyTreeChoice_${productId}`;

    function buildTree(element) {
      const name = element.querySelector('.parent-name, .child-name')?.value || '';
      const select = element.querySelector('.children-count');
      const count = select ? parseInt(select.value, 10) : 0;
      const container = element.querySelector('.children-container');
      const blocks = container ? Array.from(container.children) : [];

      return {
        name,
        children: blocks.map((child) => buildTree(child)),
      };
    }

    function saveToLocal() {
      const root = familyTreeForm.querySelector('.generation');
      if (!root) return;
      const json = buildTree(root);
      localStorage.setItem(storageKey, JSON.stringify(json));
      hiddenInput.value = JSON.stringify(json);
    }

    function loadSaved() {
      const saved = localStorage.getItem(storageKey);
      return saved ? JSON.parse(saved) : null;
    }

    function clearSaved() {
      hiddenInput.value = '';
      localStorage.removeItem(storageKey);
    }

    function hasChildren(data) {
      return data && Array.isArray(data.children) && data.children.length > 0;
    }

    function createPersonRow(gen, index) {
      const wrapperEl = document.createElement('div');
      wrapperEl.classList.add('generation');
      wrapperEl.dataset.generation = gen;
      wrapperEl.innerHTML = `
        <div class="person-row">
          <div class="field small-field">
            <label>#Child</label>
            <select class="children-count" data-generation="${gen}">
              <option value="0">0</option>
              ${Array.from({ length: 15 }, (_, i) => `<option value="${i + 1}">${i + 1}</option>`).join('')}
            </select>
          </div>

          <div class="field">
            <label class="name-label">${gen === 1 ? 'Parent Name' : `Child ${index + 1} of `}</label>
            <input type="text" class="${gen === 1 ? 'parent-name' : 'child-name'}" placeholder="Name" maxlength="25" />
          </div>
        </div>

        <div class="children-container"></div>
      `;
      return wrapperEl;
    }

    function updateChildLabels(parentGen) {
      const parentInput = parentGen.querySelector('.parent-name, .child-name');
      const parentName = parentInput ? parentInput.value.trim() : '';
      const container = parentGen.querySelector('.children-container');
      if (!container) return;

      Array.from(container.children).forEach((childGen, idx) => {
        const label = childGen.querySelector('.name-label');
        if (label) {
          label.textContent = `Child ${idx + 1} of ${parentName || ''}`;
        }
      });
    }

    function attachChildrenLogic(selectEl) {
      selectEl.addEventListener('change', function () {
        const count = parseInt(this.value, 10);
        const parentGen = this.closest('.generation');
        const container = parentGen.querySelector('.children-container');
        container.innerHTML = '';

        const gen = parseInt(parentGen.dataset.generation, 10);
        if (gen >= 5) return;

        for (let i = 0; i < count; i += 1) {
          const block = createPersonRow(gen + 1, i);
          container.appendChild(block);

          attachChildrenLogic(block.querySelector('.children-count'));
          attachSaveEvents(block);
        }

        updateChildLabels(parentGen);
        saveToLocal();
      });
    }

    function attachSaveEvents(container) {
      container.querySelectorAll('input, select').forEach((el) => {
        el.addEventListener('input', () => {
          if (el.classList.contains('parent-name') || el.classList.contains('child-name')) {
            const gen = el.closest('.generation');
            if (gen) updateChildLabels(gen);
          }
          saveToLocal();
        });

        el.addEventListener('change', () => {
          if (el.classList.contains('children-count')) {
            const gen = el.closest('.generation');
            if (gen) updateChildLabels(gen);
          }
          saveToLocal();
        });
      });
    }

    function rebuildFromJSON(data, element, gen = 1) {
      const nameField = element.querySelector('.parent-name, .child-name');
      if (nameField) nameField.value = data.name || '';

      const select = element.querySelector('.children-count');
      if (select) select.value = data.children.length;

      const container = element.querySelector('.children-container');
      if (container) container.innerHTML = '';

      data.children.forEach((child, i) => {
        const block = createPersonRow(gen + 1, i);
        container.appendChild(block);

        attachChildrenLogic(block.querySelector('.children-count'));
        attachSaveEvents(block);

        rebuildFromJSON(child, block, gen + 1);
      });

      updateChildLabels(element);
    }

    function showFamilyForm() {
      wrapper.hidden = false;
      toggleButton.setAttribute('aria-expanded', 'true');
    }

    function resetFamilyForm() {
      const root = familyTreeForm.querySelector('.generation');
      if (!root) return;
      const parentName = root.querySelector('.parent-name');
      if (parentName) parentName.value = '';
      const rootSelect = root.querySelector('.children-count[data-generation="1"]');
      if (rootSelect) {
        rootSelect.value = '0';
        rootSelect.dispatchEvent(new Event('change'));
      }
      updateChildLabels(root);
      hiddenInput.value = '';
      localStorage.removeItem(storageKey);
      localStorage.removeItem(choiceStorageKey);
      wrapper.hidden = true;
      toggleButton.setAttribute('aria-expanded', 'false');
      if (optionInputs.length) {
        optionInputs[0].checked = true;
        customizeChoiceInput.value = optionInputs[0].value;
        toggleButton.disabled = true;
      }
    }

    function handleOptionChange(value) {
      customizeChoiceInput.value = value;
      if (value === 'no_customization') {
        toggleButton.disabled = true;
        resetFamilyForm();
      } else {
        toggleButton.disabled = false;
      }
      localStorage.setItem(choiceStorageKey, value);
    }

    const rootSelect = familyTreeForm.querySelector('.children-count[data-generation="1"]');
    if (!rootSelect) return;

    attachChildrenLogic(rootSelect);
    attachSaveEvents(familyTreeForm);
    updateChildLabels(familyTreeForm.querySelector('.generation'));
    toggleButton.disabled = true;

    if (optionInputs.length) {
      optionInputs.forEach((input) => {
        input.addEventListener('change', () => handleOptionChange(input.value));
      });
    }

    const saved = loadSaved();
    const savedChoice = localStorage.getItem(choiceStorageKey);
    if (savedChoice && optionInputs.length) {
      const match = optionInputs.find((r) => r.value === savedChoice);
      if (match) {
        match.checked = true;
        handleOptionChange(savedChoice);
      }
    } else if (optionInputs.length) {
      customizeChoiceInput.value = optionInputs[0].value;
      toggleButton.disabled = true;
    }

    if (savedChoice === 'no_customization') {
      clearSaved();
      wrapper.hidden = true;
      toggleButton.setAttribute('aria-expanded', 'false');
    } else if (savedChoice === 'add_boxes_blank' || savedChoice === 'add_names_now') {
      if (saved && hasChildren(saved)) {
        const root = familyTreeForm.querySelector('.generation');
        rebuildFromJSON(saved, root);
        saveToLocal();
      }
      showFamilyForm();
      toggleButton.disabled = false;
    }

    toggleButton.addEventListener('click', () => {
      if (wrapper.hidden) {
        showFamilyForm();
        saveToLocal();
      }
    });

    closeButton.addEventListener('click', () => {
      resetFamilyForm();
    });

    form.addEventListener('submit', (event) => {
      const selected = optionInputs.find((r) => r.checked);
      const selectedVal = selected ? selected.value : 'no_customization';

      if (selectedVal !== 'no_customization') {
        const rootSelect = familyTreeForm.querySelector('.children-count[data-generation="1"]');
        const count = parseInt(rootSelect?.value || '0', 10);
        if (!count) {
          alert('Please add at least one child for customization.');
          showFamilyForm();
          rootSelect?.focus();
          event.preventDefault();
          return;
        }
      }

      const root = familyTreeForm.querySelector('.generation');
      if (!root) return;
      const json = buildTree(root);
      hiddenInput.value = JSON.stringify(json);
      localStorage.setItem(storageKey, JSON.stringify(json));
      if (optionInputs.length) {
        const selected = optionInputs.find((r) => r.checked);
        if (selected) {
          customizeChoiceInput.value = selected.value;
          localStorage.setItem(choiceStorageKey, selected.value);
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('product-info').forEach((productInfo) => initFamilyTree(productInfo));
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('product-info:loaded', (event) => {
    initFamilyTree(event.target);
  });
})();
